import { requestApi } from '~/services/api.js';

const socialLoginCall = async payload => {
	try {
		const response = await requestApi('/auth/login/social', payload, 'POST');
		return response;
	} catch {
		return {
			errorCode: 'SOCIAL_MEDIA_LOGIN_ERROR',
			status: 'FAILURE'
		};
	}
};
export default socialLoginCall;
